import { render, staticRenderFns } from "./appVersions.vue?vue&type=template&id=fff3a9f8&scoped=true&"
import script from "./appVersions.vue?vue&type=script&lang=js&"
export * from "./appVersions.vue?vue&type=script&lang=js&"
import style0 from "./appVersions.vue?vue&type=style&index=0&id=fff3a9f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff3a9f8",
  null
  
)

export default component.exports